import * as z from "zod";

export const applyUnifiedOnboardingSteps = {
  name: "applyUnifiedOnboardingSteps" as const,
  input: z.object({
    stepValues: z.record(z.string(), z.record(z.string(), z.unknown())),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
